import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { withViewExperienceTracker } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/experience-tracking';
import { connect } from '@atlassian/jira-react-redux';
import mapStateToProps from './query';
import type { OwnProps, StateProps } from './types';
import View from './view';

export { default as TimelineWidthSubscriber } from './timeline-width-subscriber';
export type { TimelineWidthSubscriberProps } from './timeline-width-subscriber';

export default withViewExperienceTracker(
	connect<StateProps, {}, OwnProps, State>(mapStateToProps, {})(View),
	'portfolio-3.simple-plans.roadmap.timeline-column',
);
